import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractApproval } from './abstract-approval';

@inheritSerialization(AbstractApproval)
export class ApprovalRequestSubmission {
  @autoserialize
  reviewerUserIds: Array<string>;

  @autoserialize
  requestorNote: string;

  @autoserialize
  approvalObject: any;
}
